import { jsx as t, jsxs as c, Fragment as W } from "react/jsx-runtime";
import { forwardRef as A, useId as B } from "react";
import { A as w } from "../../chunks/Avatar-ihLwDM5D.js";
import { B as Y } from "../../chunks/Banner-BBfZio8n.js";
import { B as d } from "../../chunks/Button-icgr8OM9.js";
import { C as k } from "../../chunks/Card-BpiP0p3P.js";
import { P as u } from "../../chunks/Pill-uAcQLotY.js";
import { A as b } from "../../chunks/AiModeBadge-DXU_Al41.js";
import { A as z } from "../../chunks/AccountStatusPill-Cz8VkI3p.js";
import { c as x } from "../../chunks/cn-DlLpp5ix.js";
import { F as M } from "../../chunks/focus-BJKdC9pu.js";
const F = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-4)"
}, P = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-3)",
  flex: "1 1 auto",
  minWidth: 0
}, $ = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "var(--space-2)"
}, D = {
  fontSize: "var(--text-xs)",
  color: "var(--text-tertiary)",
  margin: 0
}, U = {
  fontSize: "var(--text-md)",
  fontWeight: "var(--font-weight-bold)",
  color: "var(--text-primary)",
  margin: 0
}, j = {
  fontSize: "var(--text-sm)",
  color: "var(--text-secondary)",
  margin: 0
}, V = {
  display: "flex",
  flexWrap: "wrap",
  gap: "var(--space-2)"
}, G = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-1)",
  flexShrink: 0
};
function q(n) {
  switch (n) {
    case "error":
      return "error";
    case "limited":
      return "warning";
    case "paused":
      return "info";
    case "reconnecting":
      return "info";
    case "active":
    default:
      return "success";
  }
}
function H(n) {
  switch (n) {
    case "block":
      return "error";
    case "suggest":
      return "warning";
    case "manual":
    default:
      return "neutral";
  }
}
const T = A(function({
  account: e,
  status: a,
  statusInfo: o,
  defaultStatusInfo: s,
  mode: i,
  offTargetSettings: l,
  autoLeadDetect: h,
  labels: r,
  onPause: m,
  onResume: p,
  onReconnect: f,
  onEditVoice: v,
  onDisconnect: L,
  autoResumeAt: g,
  className: _
}, I) {
  const C = `${B()}-name`, N = J(a, o, s, r), S = Date.now(), y = a === "limited" && typeof g == "number" && g > S && !!r.autoResume, O = y ? g - S : 0;
  return /* @__PURE__ */ t(
    k,
    {
      ref: I,
      padding: "lg",
      radius: "2xl",
      className: x(_),
      "data-ls-composite": "account-card",
      "data-status": a,
      "data-mode": i,
      role: "article",
      "aria-labelledby": C,
      children: /* @__PURE__ */ c("div", { style: F, children: [
        /* @__PURE__ */ t(
          w,
          {
            size: "xl",
            src: e.avatarUrl,
            initials: e.initials,
            tone: e.identityColor ? "identity" : "neutral",
            identityColor: e.identityColor,
            alt: e.name
          }
        ),
        /* @__PURE__ */ c("div", { style: P, children: [
          /* @__PURE__ */ c("div", { style: $, children: [
            /* @__PURE__ */ t("h3", { id: C, style: U, children: e.name }),
            a !== "active" ? /* @__PURE__ */ t(
              z,
              {
                status: a === "reconnecting" ? "paused" : a,
                "data-render-status": a,
                children: r.status[a]
              }
            ) : null,
            /* @__PURE__ */ t(b, { mode: i === "manual" ? "review" : i, children: r.mode[i] })
          ] }),
          /* @__PURE__ */ t("p", { style: D, children: e.url }),
          N,
          y && r.autoResume ? /* @__PURE__ */ t(
            "p",
            {
              "data-region": "auto-resume-countdown",
              style: {
                margin: 0,
                fontSize: "var(--text-xs)",
                color: "var(--color-warning, var(--text-secondary))",
                fontWeight: "var(--font-weight-semibold)"
              },
              role: "status",
              "aria-live": "polite",
              children: r.autoResume.duration(O)
            }
          ) : null,
          /* @__PURE__ */ c("p", { style: j, children: [
            r.voicePrefix,
            " ",
            /* @__PURE__ */ t("em", { children: e.voice })
          ] }),
          /* @__PURE__ */ c("div", { style: V, children: [
            /* @__PURE__ */ t(u, { tone: "neutral", size: "sm", variant: "soft", children: r.businessesCount(e.businesses) }),
            /* @__PURE__ */ t(u, { tone: "neutral", size: "sm", variant: "soft", children: r.campaignsCount(e.campaigns) }),
            l.showOffTarget ? /* @__PURE__ */ t(
              u,
              {
                tone: H(l.offTargetMode),
                size: "sm",
                variant: "dashed",
                "data-pill": "off-target",
                children: r.offTarget(l.offTargetMode)
              }
            ) : null,
            h ? /* @__PURE__ */ t(u, { tone: "success", size: "sm", variant: "soft", "data-pill": "auto-leads", children: r.autoLeads }) : null,
            e.salesNav ? /* @__PURE__ */ t(u, { tone: "accent", size: "sm", variant: "soft", "data-pill": "sales-nav", children: r.salesNav }) : null
          ] })
        ] }),
        /* @__PURE__ */ c("div", { role: "group", "aria-label": r.actionsAriaLabel, style: G, children: [
          K({
            status: a,
            labels: r,
            onPause: m,
            onResume: p,
            onReconnect: f,
            autoResumeActive: y
          }),
          /* @__PURE__ */ t(d, { variant: "ghost", size: "sm", onClick: v, "data-action": "edit-voice", children: r.actions.editVoice }),
          /* @__PURE__ */ t(d, { variant: "danger", size: "sm", onClick: L, "data-action": "disconnect", children: r.actions.disconnect })
        ] })
      ] })
    }
  );
});
T.displayName = "AccountCard";
function J(n, e, a, o) {
  if (n === "active") return null;
  const s = a?.[n], i = e ?? s ?? o.status[n];
  return /* @__PURE__ */ t(Y, { tone: q(n), "data-banner-status": n, children: i });
}
function K({
  status: n,
  labels: e,
  onPause: a,
  onResume: o,
  onReconnect: s,
  autoResumeActive: i
}) {
  switch (n) {
    case "error":
      return /* @__PURE__ */ t(d, { variant: "danger", size: "sm", onClick: s, "data-action": "reconnect", children: e.actions.reconnect });
    case "paused":
      return /* @__PURE__ */ t(d, { variant: "success", size: "sm", onClick: o, "data-action": "resume", children: e.actions.resume });
    case "limited":
      return /* @__PURE__ */ t(
        d,
        {
          variant: "secondary",
          size: "sm",
          disabled: !0,
          "data-action": "auto-resume",
          title: i && e.autoResume ? e.autoResume.tooltip : void 0,
          children: e.actions.autoResume
        }
      );
    case "reconnecting":
      return /* @__PURE__ */ t(d, { variant: "ghost", size: "sm", loading: !0, "data-action": "reconnecting", children: e.actions.reconnecting });
    case "active":
    default:
      return /* @__PURE__ */ t(d, { variant: "ghost", size: "sm", onClick: a, "data-action": "pause", children: e.actions.pause });
  }
}
const Q = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--space-2)",
  padding: "var(--space-1) var(--space-2)",
  borderRadius: "var(--radius-full)",
  background: "var(--bg-elevated)",
  border: "1px solid var(--border-default)",
  fontFamily: "var(--font-sans)",
  color: "var(--text-primary)",
  textAlign: "left",
  cursor: "default"
}, X = {
  fontSize: "var(--text-xs)",
  fontWeight: "var(--font-weight-semibold)",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "12ch"
}, R = A(function({ account: e, status: a, statusLabel: o, onClick: s, size: i = "sm", className: l, ...h }, r) {
  const m = h["aria-label"] ?? `${e.name} — ${String(o)}`, p = typeof s == "function", f = {
    ...Q,
    cursor: p ? "pointer" : "default",
    padding: i === "md" ? "var(--space-2) var(--space-3)" : "var(--space-1) var(--space-2)"
  }, v = /* @__PURE__ */ c(W, { children: [
    /* @__PURE__ */ t(
      w,
      {
        size: i === "md" ? "sm" : "xs",
        src: e.avatarUrl,
        initials: e.initials,
        tone: e.identityColor ? "identity" : "neutral",
        identityColor: e.identityColor,
        alt: e.name
      }
    ),
    /* @__PURE__ */ t("span", { style: X, children: e.name }),
    /* @__PURE__ */ t(
      z,
      {
        status: a === "reconnecting" ? "paused" : a,
        size: "xs",
        variant: "soft",
        "data-render-status": a,
        children: o
      }
    )
  ] });
  return p ? /* @__PURE__ */ t(
    "button",
    {
      ref: r,
      type: "button",
      onClick: s,
      "aria-label": m,
      className: x(M, l),
      "data-ls-composite": "account-chip",
      "data-status": a,
      "data-size": i,
      style: f,
      children: v
    }
  ) : /* @__PURE__ */ t(
    "div",
    {
      ref: r,
      role: "group",
      "aria-label": m,
      className: x(l),
      "data-ls-composite": "account-chip",
      "data-status": a,
      "data-size": i,
      style: f,
      children: v
    }
  );
});
R.displayName = "AccountChip";
const E = T;
E.Chip = R;
const ue = E;
export {
  ue as AccountCard,
  R as AccountChip
};
//# sourceMappingURL=index.js.map
